import controller from './query-builder-children-group.controller';
import template from './query-builder-children-group.html';
import './query-builder-children-group.scss';

export default {
	controller,
	template,
	bindings: {
		group:   '<ngModel',
		options: '<?options',
	},
	require:  {
		parentBuilder: '^^queryBuilderChildren',
		parent:        '^^?queryBuilderChildrenGroup',
	},
};
